import Box from '@mui/material/Box'
import { useT } from '@transifex/react'
import AwardsDefaults from '../images/AwardsDefault.png'

const iconStyle = {
  width: '100%',
  height: '100%',
}

const DefaultAwardIcon = () => {
  const t = useT()
  return <Box component="img" src={AwardsDefaults} sx={iconStyle} alt={t('Awards image')} />
}

export default DefaultAwardIcon
